export const PermissionsData = `
app
 id 
 isActive 
 permissions`;
